import { gqNotifyApiClient } from './axios';
import { routes } from './routes';

export const notifyAuthPost = (body) => {
	return gqNotifyApiClient({
		method: routes.NOTIFY_AUTH.METHOD,
		url: routes.NOTIFY_AUTH.URL,
		data: body,
	});
};

export const notifyCallbackPost = (body) => {
	return gqNotifyApiClient({
		method: routes.NOTIFY_CALLBACK_REQUEST.METHOD,
		url: routes.NOTIFY_CALLBACK_REQUEST.URL,
		data: body,
	});
};

export const notifySupportReqPost = (body) => {
	return gqNotifyApiClient({
		method: routes.NOTIFY_SUPPORT_REQUEST.METHOD,
		url: routes.NOTIFY_SUPPORT_REQUEST.URL,
		data: body,
	});
};

export const notifyResetPassPost = (body) => {
	return gqNotifyApiClient({
		method: routes.NOTIFY_RESET_PASSWORD.METHOD,
		url: routes.NOTIFY_RESET_PASSWORD.URL,
		data: body,
	});
};

export const notifyCreatePassPost = (body) => {
	return gqNotifyApiClient({
		method: routes.NOTIFY_CREATE_PASSWORD.METHOD,
		url: routes.NOTIFY_CREATE_PASSWORD.URL,
		data: body,
	});
};

export const notifyMobileOtpPost = (body) => {
	return gqNotifyApiClient({
		method: routes.NOTIFY_MOBILE_OTP.METHOD,
		url: routes.NOTIFY_MOBILE_OTP.URL,
		data: body,
	});
};
